module.exports = __webpack_public_path__ + "img/map_small.fce94dec.png";